<template>
  <div>
    <div class="card m-3">
        <div class="card-body text-center">
             <h4>Esse módulo não está ativo.</h4>
        </div>
    </div>
    <template v-if="false">
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Gerenciamenteo da frota</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>

                                    <vuetable ref="vuetable"
                                            api-url="/api/frota"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="veiculo_id"
                                            pagination-path=""
                                            detail-row-component="frota-detalhes"
                                            @vuetable:cell-clicked="onDetail"
                                            @vuetable:load-error="onError"
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          </template>

                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onCreateSeguro(props.rowData, props.rowIndex)" v-b-tooltip title="Cadastrar Seguro" v-if="getPermission('frota.store.seguro')"><i class="fa fa-shield"></i></a>
                                                <a @click="onCreateAbastecimento(props.rowData, props.rowIndex)" v-b-tooltip title="Cadastrar Abastecimento" v-if="getPermission('frota.store.abastecimento')"><i class="fa fa-car"></i></a>
                                                <a @click="onCreateDocumento(props.rowData, props.rowIndex)" v-b-tooltip title="Cadastrar Documento" v-if="getPermission('frota.store.documento')"><i class="fa fa-file"></i></a>
                                                <a @click="onCreateManutencao(props.rowData, props.rowIndex)" v-b-tooltip title="Cadastrar Manutenção" v-if="getPermission('frota.store.manutencao')"><i class="fa fa-wrench"></i></a>
                                                <a @click="onCreateMulta(props.rowData, props.rowIndex)" v-b-tooltip title="Cadastrar Multa" v-if="getPermission('frota.store.multa')"><i class="fa fa-file-tex"></i></a>
                                                <a @click="onCreatePneu(props.rowData, props.rowIndex)" v-b-tooltip title="Cadastrar Pneu" v-if="getPermission('frota.store.pneu')"><i class="fa fa-dot-circle-o"></i></a>
                                                <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                              </button>
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                    <div>
                                        <div class='col-md-12'>
                                            <div class="pull-left pagination-detail">
                                                <vuetable-pagination-info ref="paginationInfo"
                                                                          :css="css.pagination"
                                                                          info-class="pull-left"
                                                ></vuetable-pagination-info>
                                            </div>
                                            <div class="pull-right m-a-0">
                                                <vuetable-pagination ref="pagination"
                                                                     :css="css.pagination"
                                                                     @vuetable-pagination:change-page="onChangePage"
                                                ></vuetable-pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
              </div>
              <!-- Modal Component -->
              <b-modal id="modal_form_seguro"
                       ref="modal_form_seguro"
                       :title="modal_titulo"
                       size="lg"
                       :ok-title="modal_botao"
                       close-title="Fechar"
                       cancel-title="Cancelar"
                       :ok-disabled=form_seguro.errors.any()
                       v-model="showModal"
                       @ok="handleOkSeguro">

             <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
               <b-row>
                 <b-col>
                   <label>Corretora</label>
                   <b-form-input type="text"
                                 placeholder="Corretora"
                                 v-model="form_seguro.corretora"
                                 name="corretora"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="form_seguro.errors.get('corretora')" v-if="form_seguro.errors.has('corretora')"></b-form-feedback>
                 </b-col>
                 <b-col>
                   <label></label>
                    <b-form-datepicker
                      locale="pt-br" 
                      reset-button
                      placeholder="Data Inicio" 
                      v-model="form_seguro.dt_inicio" 
                      class="form-control" 
                      :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                    </b-form-datepicker>
                   <b-form-feedback v-text="form_seguro.errors.get('dt_inicio')" v-if="form_seguro.errors.has('dt_inicio')"></b-form-feedback>
                  </b-col>
                  <b-col>
                    <label></label>
                    <b-form-datepicker
                      locale="pt-br" 
                      reset-button
                      placeholder="Data Fim" 
                      v-model="form_seguro.dt_fim" 
                      class="form-control" 
                      :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                    </b-form-datepicker>
                    <b-form-feedback v-text="form_seguro.errors.get('dt_fim')" v-if="form_seguro.errors.has('dt_fim')"></b-form-feedback>
                   </b-col>
               </b-row>
               <b-row>
                    <b-col>
                     <label>Valor Seguro</label>
                     <b-form-input type="text"
                                   placeholder="Valor Seguro"
                                   v-model="form_seguro.vlr_seguro"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_seguro.errors.get('vlr_seguro')" v-if="form_seguro.errors.has('vlr_seguro')"></b-form-feedback>
                   </b-col>
                  <b-col>
                      <label>Seguradora</label>
                      <multiselect v-model="form_seguro.seguradora"
                      :options="optionsSeguradora"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Tipo"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      ></multiselect>
                     <b-form-feedback v-text="form_seguro.errors.get('Seguradora')" v-if="form_seguro.errors.has('Seguradora')"></b-form-feedback>
                   </b-col>
                 <b-col>
                     <label>Status</label>
                     <multiselect v-model="form_seguro.status"
                     :options="optionsLivStatusSeguro"
                     track-by="value"
                     label="label"
                     :hide-selected="true"
                     placeholder="Tipo"
                     tag-placeholder="Selecionar"
                     select-label="Selecionar"
                     selected-label="Selecionado"
                     deselect-label="Remover"
                     ></multiselect>
                     <b-form-feedback v-text="form_seguro.errors.get('status.value')" v-if="form_seguro.errors.has('status.value')"></b-form-feedback>
                   </b-col>
               </b-row>
             </form>
                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                           <div class="float-right">
                               <b-btn @click="showModal=false" variant="secondary">
                                 Fechar
                               </b-btn>
                               <b-btn @click="handleOkSeguro($event)" variant="secondary" :disabled="isDisabled">
                                 Enviar
                               </b-btn>
                           </div>
                    </div>
                </b-modal>
                <b-modal id="modal_form_abastecimento"
                         ref="modal_form_abastecimento"
                         :title="modal_titulo"
                         size="lg"
                         :ok-title="modal_botao"
                         close-title="Fechar"
                         cancel-title="Cancelar"
                         :ok-disabled=form_abastecimento.errors.any()
                         v-model="showModalAbastecimento"
                         @ok="handleOkAbastecimento">

               <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                 <b-row>
                   <b-col>
                     <label>N° Documento</label>
                     <b-form-input type="text"
                                   placeholder="N° Documento"
                                   v-model="form_abastecimento.num_documento"
                                   name="num_documento"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_abastecimento.errors.get('num_documento')" v-if="form_abastecimento.errors.has('num_documento')"></b-form-feedback>
                   </b-col>
                   <b-col>
                     <label>Valor Documento</label>
                     <b-form-input type="text"
                                   placeholder="Valor Documento"
                                   v-model="form_abastecimento.vlr_doc"
                                   name="vlr_doc"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_abastecimento.errors.get('vlr_doc')" v-if="form_abastecimento.errors.has('vlr_doc')"></b-form-feedback>
                   </b-col>
                   <b-col>
                       <label>Data do Abastecimento</label>
                       <v-date-picker v-model="form_abastecimento.dt_abastecimento"
                                      mode='single'
                                      locale="pt-BR"
                                      v-mask="'##/##/####'"
                                      :popover='{visibility: "focus"}'
                                      :attributes='date_attributes'
                                      :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                      @keyup.enter="doFilter">
                       </v-date-picker>
                       <b-form-feedback class="text-danger" v-text="form_abastecimento.errors.get('dt_abastecimento')" v-if="form_abastecimento.errors.has('dt_abastecimento')"></b-form-feedback>
                    </b-col>
                </b-row>
                <b-row>
                   <b-col>
                     <label>Valor Litro</label>
                     <b-form-input type="text"
                                   placeholder="Valor Litro"
                                   v-model="form_abastecimento.vlr_litro"
                                   name="vlr_litro"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_abastecimento.errors.get('vlr_litro')" v-if="form_abastecimento.errors.has('vlr_litro')"></b-form-feedback>
                   </b-col>
                   <b-col>
                     <label>Quantidade de Litros</label>
                     <b-form-input type="text"
                                   placeholder="Quantidade de Litros"
                                   v-model="form_abastecimento.qtde_litros"
                                   name="qtde_litros"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_abastecimento.errors.get('qtde_litros')" v-if="form_abastecimento.errors.has('qtde_litros')"></b-form-feedback>
                   </b-col>
                  <b-col>
                   <label>KM Atual</label>
                   <b-form-input type="text"
                                 placeholder="KM Atual"
                                 v-model="form_abastecimento.km_atual"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="form_abastecimento.errors.get('km_atual')" v-if="form_abastecimento.errors.has('km_atual')"></b-form-feedback>
                 </b-col>
                   <b-col>
                       <label>Tipo Combustível</label>
                       <multiselect v-model="form_abastecimento.tp_combustivel"
                       :options="optionsLivTpCombustivel"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Tipo"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                      <b-form-feedback v-text="form_abastecimento.errors.get('tp_combustivel')" v-if="form_abastecimento.errors.has('tp_combustivel')"></b-form-feedback>
                    </b-col>
                   <b-col>
                       <label>Status</label>
                       <multiselect v-model="form_abastecimento.status"
                       :options="optionsLivStatusAbastecimento"
                       track-by="value"
                       label="label"
                       :hide-selected="true"
                       placeholder="Tipo"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       ></multiselect>
                       <b-form-feedback v-text="form_abastecimento.errors.get('status.value')" v-if="form_abastecimento.errors.has('status.value')"></b-form-feedback>
                     </b-col>
                 </b-row>
                 <b-row>
                     <b-col>
                         <label>Observação</label>
                         <b-form-textarea name="obs"
                                          v-model="form_abastecimento.obs"
                                          placeholder="Observação"
                                          :rows="3"
                                          :max-rows="6">
                         </b-form-textarea>
                         <b-form-feedback class="text-danger" v-text="form_abastecimento.errors.get('obs')" v-if="form_abastecimento.errors.has('obs')"></b-form-feedback>
                     </b-col>
                 </b-row>
               </form>
                      <div slot="modal-footer" class="w-100">
                             <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                             <div class="float-right">
                                 <b-btn @click="showModalAbastecimento=false" variant="secondary">
                                   Fechar
                                 </b-btn>
                                 <b-btn @click="handleOkAbastecimento($event)" variant="secondary" :disabled="isDisabled">
                                   Enviar
                                 </b-btn>
                             </div>
                      </div>
                  </b-modal>
                  <b-modal id="modal_form_documento"
                           ref="modal_form_documento"
                           :title="modal_titulo"
                           size="lg"
                           :ok-title="modal_botao"
                           close-title="Fechar"
                           cancel-title="Cancelar"
                           :ok-disabled=form_documento.errors.any()
                           v-model="showModalDocumento"
                           @ok="handleOkDocumento">

                 <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                   <b-row>
                     <b-col>
                       <label>N° Documento</label>
                       <b-form-input type="text"
                                     placeholder="N° Documento"
                                     v-model="form_documento.num_documento"
                                     name="num_documento"
                                     >
                       </b-form-input>
                       <b-form-feedback v-text="form_documento.errors.get('num_documento')" v-if="form_documento.errors.has('num_documento')"></b-form-feedback>
                     </b-col>
                     <b-col>
                       <label>Valor Documento</label>
                       <b-form-input type="text"
                                     placeholder="Valor Documento"
                                     v-model="form_documento.vlr_doc"
                                     name="vlr_doc"
                                     >
                       </b-form-input>
                       <b-form-feedback v-text="form_documento.errors.get('vlr_doc')" v-if="form_documento.errors.has('vlr_doc')"></b-form-feedback>
                     </b-col>
                     <b-col>
                         <label>Data de Início</label>
                         <v-date-picker v-model="form_documento.dt_inicio"
                                        mode='single'
                                        locale="pt-BR"
                                        v-mask="'##/##/####'"
                                        :popover='{visibility: "focus"}'
                                        :attributes='date_attributes'
                                        :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                        @keyup.enter="doFilter">
                         </v-date-picker>
                         <b-form-feedback class="text-danger" v-text="form_documento.errors.get('dt_inicio')" v-if="form_documento.errors.has('dt_inicio')"></b-form-feedback>
                      </b-col>
                      <b-col>
                          <label>Data de Fim</label>
                          <v-date-picker v-model="form_documento.dt_fim"
                                         mode='single'
                                         locale="pt-BR"
                                         v-mask="'##/##/####'"
                                         :popover='{visibility: "focus"}'
                                         :attributes='date_attributes'
                                         :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                         @keyup.enter="doFilter">
                          </v-date-picker>
                          <b-form-feedback class="text-danger" v-text="form_documento.errors.get('dt_fim')" v-if="form_documento.errors.has('dt_fim')"></b-form-feedback>
                       </b-col>
                       <b-col>
                           <label>Data de Vencimento</label>
                           <v-date-picker v-model="form_documento.dt_vencimento"
                                          mode='single'
                                          locale="pt-BR"
                                          v-mask="'##/##/####'"
                                          :popover='{visibility: "focus"}'
                                          :attributes='date_attributes'
                                          :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                          @keyup.enter="doFilter">
                           </v-date-picker>
                           <b-form-feedback class="text-danger" v-text="form_documento.errors.get('dt_vencimento')" v-if="form_documento.errors.has('dt_vencimento')"></b-form-feedback>
                        </b-col>
                  </b-row>
                  <b-row>
                     <b-col>
                       <label>Parcelas</label>
                       <b-form-input type="text"
                                     placeholder="Parcelas"
                                     v-model="form_documento.parcelas"
                                     name="parcelas"
                                     >
                       </b-form-input>
                       <b-form-feedback v-text="form_documento.errors.get('parcelas')" v-if="form_documento.errors.has('parcelas')"></b-form-feedback>
                     </b-col>
                     <b-col>
                         <label>Tipo Documento</label>
                         <multiselect v-model="form_documento.tp_documento"
                         :options="optionsLivTpDocumento"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Tipo"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
                         ></multiselect>
                        <b-form-feedback v-text="form_documento.errors.get('tp_documento')" v-if="form_documento.errors.has('tp_documento')"></b-form-feedback>
                      </b-col>
                     <b-col>
                         <label>Status</label>
                         <multiselect v-model="form_documento.status"
                         :options="optionsLivStatusDocumento"
                         track-by="value"
                         label="label"
                         :hide-selected="true"
                         placeholder="Tipo"
                         tag-placeholder="Selecionar"
                         select-label="Selecionar"
                         selected-label="Selecionado"
                         deselect-label="Remover"
                         ></multiselect>
                         <b-form-feedback v-text="form_documento.errors.get('status.value')" v-if="form_documento.errors.has('status.value')"></b-form-feedback>
                       </b-col>
                   </b-row>
                   <b-row>
                       <b-col>
                           <label>Observação</label>
                           <b-form-textarea name="obs"
                                            v-model="form_documento.obs"
                                            placeholder="Observação"
                                            :rows="3"
                                            :max-rows="6">
                           </b-form-textarea>
                           <b-form-feedback class="text-danger" v-text="form_documento.errors.get('obs')" v-if="form_documento.errors.has('obs')"></b-form-feedback>
                       </b-col>
                   </b-row>
                 </form>
                        <div slot="modal-footer" class="w-100">
                               <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                               <div class="float-right">
                                   <b-btn @click="showModalDocumento=false" variant="secondary">
                                     Fechar
                                   </b-btn>
                                   <b-btn @click="handleOkDocumento($event)" variant="secondary" :disabled="isDisabled">
                                     Enviar
                                   </b-btn>
                               </div>
                        </div>
                    </b-modal>
                    <b-modal id="modal_form_manutencao"
                             ref="modal_form_manutencao"
                             :title="modal_titulo"
                             size="lg"
                             :ok-title="modal_botao"
                             close-title="Fechar"
                             cancel-title="Cancelar"
                             :ok-disabled=form_documento.errors.any()
                             v-model="showModalManutencao"
                             @ok="handleOkManutencao">

                   <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                     <b-row>
                       <b-col>
                         <label>N° Documento</label>
                         <b-form-input type="text"
                                       placeholder="N° Documento"
                                       v-model="form_manutencao.num_documento"
                                       name="num_documento"
                                       >
                         </b-form-input>
                         <b-form-feedback v-text="form_manutencao.errors.get('num_documento')" v-if="form_manutencao.errors.has('num_documento')"></b-form-feedback>
                       </b-col>
                       <b-col>
                         <label>Valor Manutenção</label>
                         <b-form-input type="text"
                                       placeholder="Valor Manutenção"
                                       v-model="form_manutencao.vlr_manutencao"
                                       name="vlr_manutencao"
                                       >
                         </b-form-input>
                         <b-form-feedback v-text="form_manutencao.errors.get('vlr_manutencao')" v-if="form_manutencao.errors.has('vlr_manutencao')"></b-form-feedback>
                       </b-col>
                         <b-col>
                             <label>Data Manutenção</label>
                             <v-date-picker v-model="form_manutencao.dt_manutencao"
                                            mode='single'
                                            locale="pt-BR"
                                            v-mask="'##/##/####'"
                                            :popover='{visibility: "focus"}'
                                            :attributes='date_attributes'
                                            :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                            @keyup.enter="doFilter">
                             </v-date-picker>
                             <b-form-feedback class="text-danger" v-text="form_manutencao.errors.get('dt_manutencao')" v-if="form_manutencao.errors.has('dt_manutencao')"></b-form-feedback>
                          </b-col>
                    </b-row>
                    <b-row>
                       <b-col>
                         <label>KM Atual</label>
                         <b-form-input type="text"
                                       placeholder="KM Atual"
                                       v-model="form_manutencao.km_atual"
                                       name="km_atual"
                                       >
                         </b-form-input>
                         <b-form-feedback v-text="form_manutencao.errors.get('km_atual')" v-if="form_manutencao.errors.has('km_atual')"></b-form-feedback>
                       </b-col>
                       <b-col>
                           <label>Tipo Manutenção</label>
                           <multiselect v-model="form_manutencao.tp_manutencao"
                           :options="optionsLivTpManutencao"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Tipo"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                          <b-form-feedback v-text="form_manutencao.errors.get('tp_manutencao')" v-if="form_manutencao.errors.has('tp_manutencao')"></b-form-feedback>
                        </b-col>
                       <b-col>
                           <label>Status</label>
                           <multiselect v-model="form_manutencao.status"
                           :options="optionsLivStatusManutencao"
                           track-by="value"
                           label="label"
                           :hide-selected="true"
                           placeholder="Tipo"
                           tag-placeholder="Selecionar"
                           select-label="Selecionar"
                           selected-label="Selecionado"
                           deselect-label="Remover"
                           ></multiselect>
                           <b-form-feedback v-text="form_manutencao.errors.get('status.value')" v-if="form_manutencao.errors.has('status.value')"></b-form-feedback>
                         </b-col>
                     </b-row>
                     <b-row>
                         <b-col>
                             <label>Observação</label>
                             <b-form-textarea name="obs"
                                              v-model="form_manutencao.obs"
                                              placeholder="Observação"
                                              :rows="3"
                                              :max-rows="6">
                             </b-form-textarea>
                             <b-form-feedback class="text-danger" v-text="form_manutencao.errors.get('obs')" v-if="form_manutencao.errors.has('obs')"></b-form-feedback>
                         </b-col>
                     </b-row>
                   </form>
                          <div slot="modal-footer" class="w-100">
                                 <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                                 <div class="float-right">
                                     <b-btn @click="showModalManutencao=false" variant="secondary">
                                       Fechar
                                     </b-btn>
                                     <b-btn @click="handleOkManutencao($event)" variant="secondary" :disabled="isDisabled">
                                       Enviar
                                     </b-btn>
                                 </div>
                          </div>
                      </b-modal>
                      <b-modal id="modal_form_multa"
                               ref="modal_form_multa"
                               :title="modal_titulo"
                               size="lg"
                               :ok-title="modal_botao"
                               close-title="Fechar"
                               cancel-title="Cancelar"
                               :ok-disabled=form_documento.errors.any()
                               v-model="showModalMulta"
                               @ok="handleOkMulta">

                     <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                       <b-row>
                         <b-col>
                           <label>N° Documento</label>
                           <b-form-input type="text"
                                         placeholder="N° Documento"
                                         v-model="form_multa.num_documento"
                                         name="num_documento"
                                         >
                           </b-form-input>
                           <b-form-feedback v-text="form_multa.errors.get('num_documento')" v-if="form_multa.errors.has('num_documento')"></b-form-feedback>
                         </b-col>
                         <b-col>
                           <label>Valor Documento</label>
                           <b-form-input type="text"
                                         placeholder="Valor Documento"
                                         v-model="form_multa.vlr_doc"
                                         name="vlr_doc"
                                         >
                           </b-form-input>
                           <b-form-feedback v-text="form_multa.errors.get('vlr_doc')" v-if="form_multa.errors.has('vlr_doc')"></b-form-feedback>
                         </b-col>
                         <b-col>
                           <label>N° Multa</label>
                           <b-form-input type="text"
                                         placeholder="N° Multa"
                                         v-model="form_multa.num_multa"
                                         name="num_multa"
                                         >
                           </b-form-input>
                           <b-form-feedback v-text="form_multa.errors.get('num_multa')" v-if="form_multa.errors.has('num_multa')"></b-form-feedback>
                         </b-col>
                        <b-col>
                          <label>Descrição</label>
                          <b-form-input type="text"
                                        placeholder="Descrição"
                                        v-model="form_multa.descr"
                                        name="descr"
                                        >
                          </b-form-input>
                          <b-form-feedback v-text="form_multa.errors.get('descr')" v-if="form_multa.errors.has('descr')"></b-form-feedback>
                        </b-col>
                      </b-row>
                      <b-row>
                      <b-col>
                          <label>Data Multa</label>
                          <v-date-picker v-model="form_multa.dt_multa"
                                         mode='single'
                                         locale="pt-BR"
                                         v-mask="'##/##/####'"
                                         :popover='{visibility: "focus"}'
                                         :attributes='date_attributes'
                                         :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                         @keyup.enter="doFilter">
                          </v-date-picker>
                          <b-form-feedback class="text-danger" v-text="form_multa.errors.get('dt_multa')" v-if="form_multa.errors.has('dt_multa')"></b-form-feedback>
                       </b-col>
                       <b-col>
                           <label>Data Vencimento</label>
                           <v-date-picker v-model="form_multa.dt_vencimento"
                                          mode='single'
                                          locale="pt-BR"
                                          v-mask="'##/##/####'"
                                          :popover='{visibility: "focus"}'
                                          :attributes='date_attributes'
                                          :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                          @keyup.enter="doFilter">
                           </v-date-picker>
                           <b-form-feedback class="text-danger" v-text="form_multa.errors.get('dt_vencimento')" v-if="form_multa.errors.has('dt_vencimento')"></b-form-feedback>
                        </b-col>
                         <b-col>
                             <label>Status</label>
                             <multiselect v-model="form_multa.status"
                             :options="optionsLivStatusMulta"
                             track-by="value"
                             label="label"
                             :hide-selected="true"
                             placeholder="Tipo"
                             tag-placeholder="Selecionar"
                             select-label="Selecionar"
                             selected-label="Selecionado"
                             deselect-label="Remover"
                             ></multiselect>
                             <b-form-feedback v-text="form_multa.errors.get('status.value')" v-if="form_multa.errors.has('status.value')"></b-form-feedback>
                           </b-col>
                       </b-row>
                       <b-row>
                           <b-col>
                               <label>Observação</label>
                               <b-form-textarea name="obs"
                                                v-model="form_multa.obs"
                                                placeholder="Observação"
                                                :rows="3"
                                                :max-rows="6">
                               </b-form-textarea>
                               <b-form-feedback class="text-danger" v-text="form_multa.errors.get('obs')" v-if="form_multa.errors.has('obs')"></b-form-feedback>
                           </b-col>
                       </b-row>
                     </form>
                            <div slot="modal-footer" class="w-100">
                                   <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                                   <div class="float-right">
                                       <b-btn @click="showModalMulta=false" variant="secondary">
                                         Fechar
                                       </b-btn>
                                       <b-btn @click="handleOkMulta($event)" variant="secondary" :disabled="isDisabled">
                                         Enviar
                                       </b-btn>
                                   </div>
                            </div>
                        </b-modal>
                        <b-modal id="modal_form_pneu"
                                 ref="modal_form_pneu"
                                 :title="modal_titulo"
                                 size="lg"
                                 :ok-title="modal_botao"
                                 close-title="Fechar"
                                 cancel-title="Cancelar"
                                 :ok-disabled=form_documento.errors.any()
                                 v-model="showModalPneu"
                                 @ok="handleOkPneu">

                       <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                         <b-row>
                           <b-col>
                             <label>N° Série</label>
                             <b-form-input type="text"
                                           placeholder="N° Série"
                                           v-model="form_pneu.num_serie"
                                           name="num_serie"
                                           >
                             </b-form-input>
                             <b-form-feedback v-text="form_pneu.errors.get('num_serie')" v-if="form_pneu.errors.has('num_serie')"></b-form-feedback>
                           </b-col>
                           <b-col>
                             <label>Marca</label>
                             <b-form-input type="text"
                                           placeholder="Marca"
                                           v-model="form_pneu.marca"
                                           name="marca"
                                           >
                             </b-form-input>
                             <b-form-feedback v-text="form_pneu.errors.get('marca')" v-if="form_pneu.errors.has('marca')"></b-form-feedback>
                           </b-col>
                           <b-col>
                             <label>Modelo</label>
                             <b-form-input type="text"
                                           placeholder="Modelo"
                                           v-model="form_pneu.modelo"
                                           name="modelo"
                                           >
                             </b-form-input>
                             <b-form-feedback v-text="form_pneu.errors.get('modelo')" v-if="form_pneu.errors.has('modelo')"></b-form-feedback>
                           </b-col>
                           <b-col>
                             <label>Dimensão</label>
                             <b-form-input type="text"
                                           placeholder="Dimensão"
                                           v-model="form_pneu.dimensao"
                                           name="dimensao"
                                           >
                             </b-form-input>
                             <b-form-feedback v-text="form_pneu.errors.get('dimensao')" v-if="form_pneu.errors.has('dimensao')"></b-form-feedback>
                           </b-col>
                           <b-col>
                             <label>KM Pneu</label>
                             <b-form-input type="text"
                                           placeholder="KM Pneu"
                                           v-model="form_pneu.km_pneu"
                                           name="km_pneu"
                                           >
                             </b-form-input>
                             <b-form-feedback v-text="form_pneu.errors.get('km_pneu')" v-if="form_pneu.errors.has('km_pneu')"></b-form-feedback>
                           </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <label>Eixos</label>
                                <multiselect v-model="form_pneu.eixo"
                                :options="optionsLivEixo"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Tipo"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback v-text="form_pneu.errors.get('eixo.value')" v-if="form_pneu.errors.has('eixo.value')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>Posição</label>
                                  <multiselect v-model="form_pneu.posicao"
                                  :options="optionsLivPosicao"
                                  track-by="value"
                                  label="label"
                                  :hide-selected="true"
                                  placeholder="Tipo"
                                  tag-placeholder="Selecionar"
                                  select-label="Selecionar"
                                  selected-label="Selecionado"
                                  deselect-label="Remover"
                                  ></multiselect>
                                  <b-form-feedback v-text="form_pneu.errors.get('posicao.value')" v-if="form_pneu.errors.has('posicao.value')"></b-form-feedback>
                                </b-col>
                        <b-col>
                            <label>Data Instalação</label>
                            <v-date-picker v-model="form_pneu.dt_instalacao"
                                           mode='single'
                                           locale="pt-BR"
                                           v-mask="'##/##/####'"
                                           :popover='{visibility: "focus"}'
                                           :attributes='date_attributes'
                                           :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                           @keyup.enter="doFilter">
                            </v-date-picker>
                            <b-form-feedback class="text-danger" v-text="form_pneu.errors.get('dt_instalacao')" v-if="form_pneu.errors.has('dt_instalacao')"></b-form-feedback>
                         </b-col>
                           <b-col>
                               <label>Status</label>
                               <multiselect v-model="form_pneu.status"
                               :options="optionsLivStatusPneu"
                               track-by="value"
                               label="label"
                               :hide-selected="true"
                               placeholder="Tipo"
                               tag-placeholder="Selecionar"
                               select-label="Selecionar"
                               selected-label="Selecionado"
                               deselect-label="Remover"
                               ></multiselect>
                               <b-form-feedback v-text="form_pneu.errors.get('status.value')" v-if="form_pneu.errors.has('status.value')"></b-form-feedback>
                             </b-col>
                         </b-row>
                         <b-row>
                             <b-col>
                                 <label>Observação</label>
                                 <b-form-textarea name="obs"
                                                  v-model="form_pneu.obs"
                                                  placeholder="Observação"
                                                  :rows="3"
                                                  :max-rows="6">
                                 </b-form-textarea>
                                 <b-form-feedback class="text-danger" v-text="form_pneu.errors.get('obs')" v-if="form_pneu.errors.has('obs')"></b-form-feedback>
                             </b-col>
                         </b-row>
                       </form>
                              <div slot="modal-footer" class="w-100">
                                     <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                                     <div class="float-right">
                                         <b-btn @click="showModalPneu=false" variant="secondary">
                                           Fechar
                                         </b-btn>
                                         <b-btn @click="handleOkPneu($event)" variant="secondary" :disabled="isDisabled">
                                           Enviar
                                         </b-btn>
                                     </div>
                              </div>
                          </b-modal>
          </div>
      </div>
      </template>
    </div>
  </template>
<script>
import { formatCNPJFromParts } from "../utils";

import Vuetable from '../components/Vuetable'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import moment from 'moment'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import FrotaFilterBar from './FrotaFilterBar'
import FrotaDetalhes from './FrotaDetalhes'

Vue.component('frota-detalhes', FrotaDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': FrotaFilterBar,
    },
    data () {
        return {
          date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showModalAbastecimento: false,
          showModalDocumento: false,
          showModalManutencao: false,
          showModalMulta: false,
          showModalPneu: false,
          helpForm: new Form({statusRecord: [], params: [], search:''}),
          optionsLivStatus: [],
          optionsLivStatusAbastecimento: [],
          optionsLivTpCombustivel: [],
          optionsLivStatusDocumento: [],
          optionsLivTpDocumento: [],
          optionsLivStatusManutencao: [],
          optionsLivTpManutencao: [],
          optionsLivStatusMulta: [],
          optionsLivStatusPneu: [],
          optionsLivEixo: [],
          optionsLivPosicao: [],
          optionsSeguradora: [],
          optionsLivStatusSeguro: [],
          form_seguro: new Form({ corretora: '',
                           dt_inicio: '',
                           dt_fim: '',
                           vlr_seguro: '',
                           seguradora: [],
                           status: [],
                           veiseg_id: '',
                           veiculo_id: ''
                       }),
          form_abastecimento: new Form({ num_documento: '',
                          vlr_doc: '',
                          dt_abastecimento: '',
                          vlr_litro: '',
                          qtde_litros: '',
                          km_atual: '',
                          tp_combustivel: [],
                          vlr_abastecimento: '',
                          status:[],
                          obs: '',
                          veiaba_id: '',
                          veiculo_id: ''
                        }),
        form_documento: new Form({ num_documento: '',
                        vlr_doc: '',
                        dt_vencimento: '',
                        dt_inicio: '',
                        dt_fim: '',
                        parcelas: '',
                        tp_documento: [],
                        status:[],
                        obs: '',
                        veidoc_id: '',
                        veiculo_id: ''
                      }),
        form_manutencao: new Form({ num_documento: '',
                          vlr_manutencao: '',
                          dt_manutencao: '',
                          km_atual: '',
                          tp_manutencao: [],
                          status:[],
                          obs: '',
                          veiman_id: '',
                          veiculo_id: ''
                        }),
        form_multa: new Form({ num_documento: '',
                        descr: '',
                        dt_vencimento: '',
                        dt_multa: '',
                        num_multa: '',
                        vlr_doc: '',
                        status:[],
                        obs: '',
                        veiman_id: '',
                        veiculo_id: ''
                      }),
        form_pneu: new Form({ num_serie: '',
                          marca: '',
                          modelo: '',
                          dimensao: '',
                          km_pneu: '',
                          dt_instalacao: '',
                          status:[],
                          eixo:[],
                          posicao:[],
                          obs: '',
                          veipne_id: '',
                          veiculo_id: ''
                        }),
        fields: [
          {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          },
          {
            name: 'placa',
            title: 'Placa',
            sortField: 'placa'
          },
          {
            name: 'renavam',
            title: 'Revanam',
            sortField: 'renavam'
          },
          {
            name: 'param_tipo_veiculo.descr',
            title: 'Tipo de veículo',
          },
          {
            name: 'param_tipo_rodado.descr',
            title: 'Tipo Rodado',
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          tableClass: 'table table-striped',
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        // this.getLivGeral();
      },
      created() {
          let self = this;
          Event.$on('editSeguro', function (data) {
              self.onEditSeguro(data, null);
          });
          Event.$on('editAbastecimento', function (data) {
              self.onEditAbastecimento(data, null);
          });
          Event.$on('editDocumento', function (data) {
              self.onEditDocumento(data, null);
          });
          Event.$on('editManutencao', function (data) {
              self.onEditManutencao(data, null);
          });
          Event.$on('editMulta', function (data) {
              self.onEditMulta(data, null);
          });
          Event.$on('editPneu', function (data) {
              self.onEditPneu(data, null);
          });
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'cpf': data_filter.cpf,
                'nome': data_filter.nome,
                'status': data_filter.status.value
            }
            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        handleOkSeguro(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreSeguro();
            }
            else
            {
                this.onUpdateSeguro(this.form_seguro.veiseg_id);
            }
        },
        onCreateSeguro (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar Seguro";
          this.modal_botao = "Cadastrar Seguro";
          this.modal_acao = "i";
          this.form_seguro.reset();
          this.form_seguro.veiculo_id = data.veiculo_id;
          this.$refs.modal_form_seguro.show();
        },
        onEditSeguro (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Alterar";
          this.modal_botao = "Alterar";
          this.modal_acao = "u";
          this.form_seguro.reset();
          this.form_seguro.corretora = data.corretora;
          this.form_seguro.vlr_seguro = data.vlr_seguro;
          this.form_seguro.dt_inicio = new Date(data.dt_inicio);
          this.form_seguro.dt_fim = new Date(data.dt_fim);
          this.form_seguro.seguradora = { label: data.seguradora.nome, value: data.seguradora.segurado_id };
          this.form_seguro.status = { label: data.status.descr, value: data.status.valor };
          this.form_seguro.veiculo_id = data.veiculo_id;
          this.form_seguro.veiseg_id = data.veiseg_id;
          this.$refs.modal_form_seguro.show();
        },
        onStoreSeguro()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_seguro.dt_inicio = this.formatDateSubmit(this.form_seguro.dt_inicio);
            this.form_seguro.dt_fim = this.formatDateSubmit(this.form_seguro.dt_fim);
            this.form_seguro.post('/api/frota/store/seguro').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdateSeguro(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_seguro.dt_inicio = this.formatDateSubmit(this.form_seguro.dt_inicio);
            this.form_seguro.dt_fim = this.formatDateSubmit(this.form_seguro.dt_fim);
            this.form_seguro.post('/api/frota/update/seguro/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        handleOkAbastecimento(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreAbastecimento();
            }
            else
            {
                this.onUpdateAbastecimento(this.form_abastecimento.veiaba_id);
            }
        },
        onCreateAbastecimento (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar Abastecimento";
          this.modal_botao = "Cadastrar Abastecimento";
          this.modal_acao = "i";
          this.form_abastecimento.reset();
          this.form_abastecimento.veiculo_id = data.veiculo_id;
          this.$refs.modal_form_abastecimento.show();
        },
        onEditAbastecimento (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar";
            this.modal_botao = "Alterar";
            this.modal_acao = "u";
            this.form_abastecimento.reset();
            this.form_abastecimento.num_documento = data.num_documento;
            this.form_abastecimento.obs = data.obs;
            this.form_abastecimento.vlr_doc = data.vlr_doc;
            this.form_abastecimento.vlr_litro = data.vlr_litro;
            this.form_abastecimento.qtde_litros = data.qtde_litros;
            this.form_abastecimento.km_atual = data.km_atual;
            this.form_abastecimento.dt_abastecimento = new Date(data.dt_abastecimento);
            this.form_abastecimento.tp_combustivel = { label: data.tp_combustivel.descr, value: data.tp_combustivel.valor };
            this.form_abastecimento.status = { label: data.status.descr, value: data.status.valor };
            this.form_abastecimento.veiculo_id = data.veiculo_id;
            this.form_abastecimento.veiaba_id = data.veiaba_id;
            this.$refs.modal_form_abastecimento.show();
        },
        onStoreAbastecimento()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_abastecimento.dt_abastecimento = this.formatDateSubmit(this.form_abastecimento.dt_abastecimento);
            this.form_abastecimento.post('/api/frota/store/abastecimento').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdateAbastecimento(id)
        {
            this.loading = true;
            this.isDisabled = true;console.log(this.form_abastecimento.dt_abastecimento);console.log(this.formatDateSubmit(this.form_abastecimento.dt_abastecimento));
            this.form_abastecimento.dt_abastecimento = this.formatDateSubmit(this.form_abastecimento.dt_abastecimento);
            this.form_abastecimento.post('/api/frota/update/abastecimento/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        handleOkDocumento(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreDocumento();
            }
            else
            {
                this.onUpdateDocumento(this.form_documento.veidoc_id);
            }
        },
        onCreateDocumento (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar Documento";
          this.modal_botao = "Cadastrar Documento";
          this.modal_acao = "i";
          this.form_documento.reset();
          this.form_documento.veiculo_id = data.veiculo_id;
          this.$refs.modal_form_documento.show();
        },
        onEditDocumento (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar";
            this.modal_botao = "Alterar";
            this.modal_acao = "u";
            this.form_documento.reset();
            this.form_documento.num_documento = data.num_documento;
            this.form_documento.obs = data.obs;
            this.form_documento.vlr_doc = data.vlr_doc;
            this.form_documento.parcelas = data.parcelas;
            this.form_documento.dt_inicio = new Date(data.dt_inicio);
            this.form_documento.dt_fim = new Date(data.dt_fim);
            this.form_documento.dt_vencimento = new Date(data.dt_vencimento);
            this.form_documento.tp_documento = { label: data.tp_documento.descr, value: data.tp_documento.valor };
            this.form_documento.status = { label: data.status.descr, value: data.status.valor };
            this.form_documento.veidoc_id = data.veidoc_id;
            this.$refs.modal_form_documento.show();
        },
        onStoreDocumento()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_documento.dt_inicio = this.formatDateSubmit(this.form_documento.dt_inicio);
            this.form_documento.dt_fim = this.formatDateSubmit(this.form_documento.dt_fim);
            this.form_documento.dt_vencimento = this.formatDateSubmit(this.form_documento.dt_vencimento);
            this.form_documento.post('/api/frota/store/documento').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdateDocumento(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_documento.dt_inicio = this.formatDateSubmit(this.form_documento.dt_inicio);
            this.form_documento.dt_vencimento = this.formatDateSubmit(this.form_documento.dt_vencimento);
            this.form_documento.dt_vencimento = this.formatDateSubmit(this.form_documento.dt_vencimento);
            this.form_documento.post('/api/frota/update/documento/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        handleOkManutencao(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreManutencao();
            }
            else
            {
                this.onUpdateManutencao(this.form_manutencao.veiman_id);
            }
        },
        onCreateManutencao (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar Manutenção";
          this.modal_botao = "Cadastrar Manutenção";
          this.modal_acao = "i";
          this.form_manutencao.reset();
          this.form_manutencao.veiculo_id = data.veiculo_id;
          this.$refs.modal_form_manutencao.show();
        },
        onEditManutencao (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar";
            this.modal_botao = "Alterar";
            this.modal_acao = "u";
            this.form_manutencao.reset();
            this.form_manutencao.num_documento = data.num_documento;
            this.form_manutencao.obs = data.obs;
            this.form_manutencao.vlr_manutencao = data.vlr_manutencao;
            this.form_manutencao.km_atual = data.km_atual;
            this.form_manutencao.dt_manutencao = new Date(data.dt_manutencao);
            this.form_manutencao.tp_manutencao = { label: data.tp_manutencao.descr, value: data.tp_manutencao.valor };
            this.form_manutencao.status = { label: data.status.descr, value: data.status.valor };
            this.form_manutencao.veiman_id = data.veiman_id;
            this.$refs.modal_form_manutencao.show();
        },
        onStoreManutencao()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_manutencao.dt_manutencao = this.formatDateSubmit(this.form_manutencao.dt_manutencao);
            this.form_manutencao.post('/api/frota/store/manutencao').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdateManutencao(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_manutencao.dt_manutencao = this.formatDateSubmit(this.form_manutencao.dt_manutencao);
            this.form_manutencao.post('/api/frota/update/manutencao/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        handleOkMulta(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStoreMulta();
            }
            else
            {
                this.onUpdateMulta(this.form_multa.veimul_id);
            }
        },
        onCreateMulta (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar Multa";
          this.modal_botao = "Cadastrar Multa";
          this.modal_acao = "i";
          this.form_multa.reset();
          this.form_multa.veiculo_id = data.veiculo_id;
          this.$refs.modal_form_multa.show();
        },
        onEditMulta (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar";
            this.modal_botao = "Alterar";
            this.modal_acao = "u";
            this.form_multa.reset();
            this.form_multa.num_documento = data.num_documento;
            this.form_multa.num_multa = data.num_multa;
            this.form_multa.obs = data.obs;
            this.form_multa.vlr_doc = data.vlr_doc;
            this.form_multa.descr = data.descr;
            this.form_multa.dt_multa = new Date(data.dt_multa);
            this.form_multa.dt_vencimento = new Date(data.dt_vencimento);
            this.form_multa.status = { label: data.status.descr, value: data.status.valor };
            this.form_multa.veimul_id = data.veimul_id;
            this.$refs.modal_form_multa.show();
        },
        onStoreMulta()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_multa.dt_multa = this.formatDateSubmit(this.form_multa.dt_multa);
            this.form_multa.dt_vencimento = this.formatDateSubmit(this.form_multa.dt_vencimento);
            this.form_multa.post('/api/frota/store/multa').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdateMulta(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_multa.dt_multa = this.formatDateSubmit(this.form_multa.dt_multa);
            this.form_multa.dt_vencimento = this.formatDateSubmit(this.form_multa.dt_vencimento);
            this.form_multa.post('/api/frota/update/multa/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        handleOkPneu(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStorePneu();
            }
            else
            {
                this.onUpdatePneu(this.form_pneu.veipne_id);
            }
        },
        onCreatePneu (data, index)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Cadastrar Pneu";
          this.modal_botao = "Cadastrar Pneu";
          this.modal_acao = "i";
          this.form_pneu.reset();
          this.form_pneu.veiculo_id = data.veiculo_id;
          this.$refs.modal_form_pneu.show();
        },
        onEditPneu (data, index)
        {
            this.isDisabled = false;
            this.loading = false;
            this.modal_titulo = "Alterar";
            this.modal_botao = "Alterar";
            this.modal_acao = "u";
            this.form_pneu.reset();
            this.form_pneu.num_serie = data.num_serie;
            this.form_pneu.marca = data.marca;
            this.form_pneu.modelo = data.modelo;
            this.form_pneu.dimensao = data.dimensao;
            this.form_pneu.km_pneu = data.km_pneu;
            this.form_pneu.dt_instalacao = new Date(data.dt_instalacao);
            this.form_pneu.obs = data.obs;
            this.form_pneu.eixo = { label: data.eixo.descr, value: data.eixo.valor };
            this.form_pneu.posicao = { label: data.posicao.descr, value: data.posicao.valor };
            this.form_pneu.status = { label: data.status.descr, value: data.status.valor };
            this.form_pneu.veipne_id = data.veipne_id;
            this.$refs.modal_form_pneu.show();
        },
        onStorePneu()
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_pneu.dt_instalacao = this.formatDateSubmit(this.form_pneu.dt_instalacao);
            this.form_pneu.post('/api/frota/store/pneu').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onUpdatePneu(id)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form_pneu.dt_instalacao = this.formatDateSubmit(this.form_pneu.dt_instalacao);
            this.form_pneu.post('/api/frota/update/pneu/'+id).then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getLivGeral()
        {
            this.helpForm.post('/api/frota/jsonlistgeral').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.status_seguro.forEach((obj)=>
                {
                    this.optionsLivStatusSeguro.push({ label: obj.descr, value: obj.valor })
                })
                response.seguradora.forEach((obj)=>
                {
                    this.optionsSeguradora.push({ label: obj.nome, value: obj.segurado_id })
                })
                response.status_veiculo_abastecimento.forEach((obj)=>
                {
                    this.optionsLivStatusAbastecimento.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_combustivel.forEach((obj)=>
                {
                    this.optionsLivTpCombustivel.push({ label: obj.descr, value: obj.valor })
                })
                response.status_veiculo_documento.forEach((obj)=>
                {
                    this.optionsLivStatusDocumento.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_documento.forEach((obj)=>
                {
                    this.optionsLivTpDocumento.push({ label: obj.descr, value: obj.valor })
                })
                response.status_veiculo_manutencao.forEach((obj)=>
                {
                    this.optionsLivStatusManutencao.push({ label: obj.descr, value: obj.valor })
                })
                response.tp_manutencao.forEach((obj)=>
                {
                    this.optionsLivTpManutencao.push({ label: obj.descr, value: obj.valor })
                })
                response.status_veiculo_multa.forEach((obj)=>
                {
                    this.optionsLivStatusMulta.push({ label: obj.descr, value: obj.valor })
                })
                response.status_veiculo_pneu.forEach((obj)=>
                {
                    this.optionsLivStatusPneu.push({ label: obj.descr, value: obj.valor })
                })
                response.eixo.forEach((obj)=>
                {
                    this.optionsLivEixo.push({ label: obj.descr, value: obj.valor })
                })
                response.posicao.forEach((obj)=>
                {
                    this.optionsLivPosicao.push({ label: obj.descr, value: obj.valor })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        limitText (count) {
          return ' e ${count} outras pessoas'
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
                onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
          return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
        },
        DateFormat: function(date) {
          if(date != null){
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
          return "";
        },
        formatTypedDate: function (dateString)
        {
           let result = dateString.split('/')
           return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.veiculo_id);
        },
        onActivateDesactivate(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push({ id: data.veiculo_id, status: action });
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push({ id: obj, status: action })
                });
            }
            this.helpForm.post('/api/veiculo/status').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });

        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>